export default __webpack_public_path__ + "img/euFkQlAH.ebb03541.svg";